
import { Component, Vue } from "vue-property-decorator";
import BaseButton from "@/components/BaseButton.vue";

@Component({
  components: {
    BaseButton,
  },
})
export default class TheHeader extends Vue {
  linksList = [
    {
      name: "CatalogPage",
      title: "Catalog",
      img: "catalogIcon",
    },
    {
      name: "ContactPage",
      title: "Contact",
      img: "contactIcon",
    },
  ];

  get authButtonText() {
    return this.$store.state.user.isAuthenticated ? "Profile" : "Sign Up";
  }

  get countCart() {
    return this.$store.getters["cart/getCartCount"];
  }

  authAction(): void {
    if (this.$route.name === "LoginPage") return;
    this.$router.push({
      name: `${
        this.$store.state.user.isAuthenticated ? "AccountPage" : "LoginPage"
      }`,
    });
  }
}
